import React from "react";

function Hero() {
  return (
    <div>
      <section className="flex flex-col items-center gap-8 px-[75px] pt-[50px] md:pt-[150px] pb-[0px] text-center text-foreground bg-background">
        <h1 className="text-4xl md:text-6xl md:leading-tight font-light">
          End-to-End Payments <br className="hidden md:inline-block" />
          Consulting for Scalable Growth
          <span className="text-brand">.</span>
        </h1>
        <h2 className="text-sm md:text-base max-w-[800px] text-muted-foreground leading-6 font-medium">
          We partner with businesses to improve approval rate performance, lower
          total cost of payments and expand into new markets — powered by expert
          guidance, actionable analytics and a modernized payments stack.
        </h2>
        <a
          href="#contact"
          className="inline-block px-5 py-3 bg-background border border-brand-600 text-foreground text-base font-bold rounded-lg transition hover:bg-brand-600 hover:text-background"
        >
          Learn More
        </a>
      </section>
    </div>
  );
}

export default Hero;
